import PropTypes from 'prop-types';
import React, { Component } from 'react';
import catchLifeCycleErrors from 'utils/catchLifeCycleErrors';

import {StandardPage} from "../../Common/pages/StandardPage";
import {RightColumn} from "../../Common/pages/RightColumn";

@catchLifeCycleErrors
export default class InsightsPage extends Component {
  static propTypes = {
    InsightDescriptionsContainer: PropTypes.element,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      InsightDescriptionsContainer,
    } = this.props;

    return (
      <StandardPage sport="racing" title="Insights">
        <div className="main-layout-left-column">
          {InsightDescriptionsContainer}
        </div>

        <RightColumn location={location}
                     sport="racing"
                     content={
                       ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"]}/>
      </StandardPage>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/InsightsPage.js